<template>
  <div class="container">
      <h1 class="heading">Program <a href="/files/Recital.pdf" target="_blank" class="h5 cvpa-link heading" title="Download recital"><b-icon-download></b-icon-download> download</a></h1>
      <b-card no-body>
        <div class="form-group mx-3 mt-3">
            <div class="input-group">
                <input ref="searchInput" type="text" class="form-control" placeholder="Search by Name or Song Title..." v-model="searchTerm" @keypress.enter="search">
                <button type="button" class="input-group-append btn btn-danger  rounded-0" @click="clear" v-show="searchTerm.length > 2">
                    <span><b-icon-x></b-icon-x></span>
                </button>
                <button type="button" class="input-group-append btn btn-outline-danger rounded-0" @click="search" v-show="searchTerm.length > 2">
                    <span><b-icon-search></b-icon-search></span>
                </button>                
            </div>
            <span class="small text-muted">Requires at least 3 charaters to search. Use , (comma) to do multiple searches.</span>
        </div>        
        <b-tabs pills lazy
                nav-class="cvpa-recital-tabs"
                align="center" v-model="tabIndex">
          <b-tab :title="recital.DisplayStartsAt" v-for="(recital, index) in recitals" :key="index" class="p-0" title-item-class="h5 font-weight-bold heading">
            <recital-acts v-model="recital.Acts" :search-term="searchTerm"></recital-acts>
          </b-tab>
        </b-tabs>
      </b-card>
  </div>
</template>


<script>
  import ProductService from "../services/ProductService";
  import RecitalActs from "../components/RecitalActs";

  export default {
    components: {
      RecitalActs
    },
    async mounted() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      this.recitals = await ProductService.recitals();

      var tabIndex = this.$route.query.r;
      if (tabIndex != undefined) {
        tabIndex = Math.min(Math.max(parseInt(tabIndex), 0), 3)
        console.log(tabIndex);
        this.$nextTick(() => {
          this.tabIndex = tabIndex;
        });
      }
      else {
        //default tab
        for (var i = 0; i < this.recitals.length; i++) {
          var recital = this.recitals[i];
          var startDate = new Date(Date.parse(recital.StartsAt));
          startDate.setHours(0, 0, 0, 0);
          if (today.getTime() == startDate.getTime()) {
            this.$nextTick(() => {
              this.tabIndex = i;
            });
            break;
          }
        }
      }
    },
    data() {
      return {
        recitals: [],
        tabIndex: 0,
        searchTerm: ""
      };
    },
    methods: {
      search() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          this.$refs["searchInput"].blur();
        } 
      },
      clear() {
        this.searchTerm = "";
        this.search();
      }
    }
  }
</script>
